import { R3TemplateDependencyKind } from '@angular/compiler';
import {
  KeycloakEvent,
  KeycloakEventType,
  KeycloakOptions,
  KeycloakService,
} from 'keycloak-angular';
import { environment } from 'src/environments/environment';

export function initializer(keycloak: KeycloakService): () => Promise<boolean> {
  //const kcEnabled = false;
  //if(kcEnabled){

  keycloak.keycloakEvents$.subscribe((event: KeycloakEvent) => {
    if (event.type == KeycloakEventType.OnTokenExpired) {
      keycloak.updateToken(30).then((data) => {
        if (data) {
          console.log('token refreshed!');
        } else {
          console.log('token refreshed failed!');
        }
      });
    }
  });
    keycloak.keycloakEvents$.subscribe((event:KeycloakEvent)=>{
        if(event.type == KeycloakEventType.OnTokenExpired){
            keycloak.updateToken(3000).then((data)=>{
                if(data){
                    console.log("token refreshed!");
                }else{
                    console.log("token refreshed failed!");
                }
            })
        }
    });

  const options: KeycloakOptions = {
    config: environment.keycloak,
    loadUserProfileAtStartUp: true,
    initOptions: {
      onLoad: 'login-required',
      checkLoginIframe: false,
      pkceMethod: 'S256',
    },
    bearerExcludedUrls: [environment.sapdomain]
  };

  /*const updateToken = async (): Promise < string > => {
        const {success,error} = keycloakAuth.updateToken(5);
        return new Promise < string > ((res, rej) => {
            success(() => res(keycloakAuth.token!));
            error(rej);
        });
    }*/

  // const keycloakAuth = keycloak.getKeycloakInstance();

  // keycloakAuth.onTokenExpired = () =>{
  //     if(keycloakAuth.refreshToken){
  //         keycloakAuth.updateToken(30).then((data)=>{
  //             if(data){
  //                 console.log("token refreshed!");
  //             }else{
  //                 console.log("token refreshed failed!");
  //             }
  //         })
  //     }else{
  //         //login
  //         keycloakAuth.login().then((data)=>{
  //             console.log("logging in!");
  //         })
  //     }
  // }

  return () => keycloak.init(options);
  /*}else{
        return () => Promise.reject();
    }*/
}
